import { useEffect, useRef } from 'react';
import './Projects.css';

const Projects = () => {
  const projectsRef = useRef(null);
  
  useEffect(() => {
    const node = projectsRef.current;
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    }, {
      threshold: 0.2,
    });
    
    if (node) {
      observer.observe(node);
    }
    
    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  const projects = [
    {
      title: "Patient Appointment System",
      status: "Completed",
      description: "A web application that allows users to schedule and manage medical appointments. Provides real-time availability, automated reminders, and a user-friendly interface for both patients and staff.",
      features: [
        "Process appointment requests",
        "Manage patient records",
        "Process Patient Data",
      ],
      techStack: ["C++"],
      github: "https://github.com/VincentDev21/Seneca-IPC144/tree/main/Milestone",
      website: "",
      tags: ["C++", "Terminal"]
    },
    {
      title: "Discord-RAT",
      status: "Maintained",
      description: "A Python program that acts like a Remote Administration Tool (RAT) that allows users to interact with a Discord server via commands. Provides powerful server management capabilities through simple chat commands.",
      features: [
        "Command parsing and execution",
        "User permission management",
        "Server statistics and monitoring",
        "Customizable command prefixes"
      ],
      techStack: ["Python", "Discord.py"],
      github: "https://github.com/VincentDev21/Discord-Bot-Rat",
      website: "",
      tags: ["Python", "Discord Bot"]
    },
    {
      title: "Text Encryptor",
      status: "Completed",
      description: "A Python program that encrypts and decrypts text using various algorithms. It provides a simple command-line interface for users to securely encrypt their messages.",
      features: [
        "User-friendly command-line interface",
        "File input/output for batch processing",
        "Customizable encryption keys"
      ],
      techStack: ["Python", "gui.py", "pycryptodome.py", "PyQt5.py"],
      github: "https://github.com/VincentDev21/Text-Encryptor",
      website: "",
      tags: ["Python", "Encryption"]
    },
  ];

  return (
    <section className="projects-section" id="projects">
      <div ref={projectsRef} className="projects-container">
        <h2 className="project-heading">My <span className="highlight">Projects</span></h2>
        
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div className="project-card" key={index}>
              <div className="project-header">
                <h3 className="project-title">{project.title}</h3>
                <div className="project-meta">
                  <span className={`project-status ${project.status.toLowerCase().replace(' ', '-')}`}>
                    {project.status}
                  </span>
                </div>
              </div>
              
              <p className="project-description">{project.description}</p>
              
              <div className="project-features">
                <ul>
                  {project.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </div>
              
              <div className="tech-stack">
                {project.techStack.map((tech, i) => (
                  <span className="tech-badge" key={i}>{tech}</span>
                ))}
              </div>
              
              <div className="project-tags">
                {project.tags.map((tag, i) => (
                  <span className="project-tag" key={i}>{tag}</span>
                ))}
              </div>
              
              <div className="project-links">
                {project.github && (
                  <a href={project.github} target="_blank" rel="noopener noreferrer" className="github-link">
                    <i className="fab fa-github"></i> GitHub
                  </a>
                )}
                {project.website && (
                  <a href={project.website} target="_blank" rel="noopener noreferrer" className="website-link">
                    <i className="fas fa-globe"></i> Website
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;